import moment from 'moment';

// expiresIn is in seconds
const storeAccessToken = (accessToken: string, expiresIn: number = 0) => {
  deleteAccessToken();
  const expirationDate = moment().add(expiresIn, 'seconds').toDate();

  document.cookie = `access_token=${accessToken};expires=${expirationDate.toUTCString()};path=/`;
};

const getAccessToken = (): string => {
  return document.cookie.match('(^|;)\\s*access_token\\s*=\\s*([^;]+)')?.pop() || '';
};

// TODO: check if it is better to just add document.cookie.indexOf('access_token')
const accessTokenExists = (): boolean => {
  const accessTokenCookieValue = getAccessToken();

  return accessTokenCookieValue !== null && accessTokenCookieValue !== undefined && accessTokenCookieValue !== '';
};

const deleteAccessToken = () => {
  document.cookie = 'access_token= ; expires = Thu, 01 Jan 1970 00:00:00 GMT; path=/';
};

const AUTH_LOGOUT_CHANNEL_NAME = 'auth-logout';

/**
 * Clears the auth cookie and notifies other tabs via BroadcastChannel so they redirect to login.
 * Auth is stored only in cookies; BroadcastChannel is used for cross-tab logout signalling.
 */
const logoutAndNotifyOtherTabs = () => {
  deleteAccessToken();
  try {
    new BroadcastChannel(AUTH_LOGOUT_CHANNEL_NAME).postMessage('logout');
  } catch {
    // BroadcastChannel not supported (e.g. old browser); other tabs won't be notified
  }
};

/**
 * Subscribes to logout from another tab (BroadcastChannel message).
 * Call the returned function to unsubscribe.
 */
const subscribeToLogoutFromOtherTab = (onLogout: () => void): (() => void) => {
  let channel: BroadcastChannel;
  try {
    channel = new BroadcastChannel(AUTH_LOGOUT_CHANNEL_NAME);
  } catch {
    return () => {};
  }
  const handler = (e: MessageEvent) => {
    if (e.data === 'logout') {
      onLogout();
    }
  };
  channel.addEventListener('message', handler);
  return () => {
    channel.removeEventListener('message', handler);
    channel.close();
  };
};

export {
  storeAccessToken,
  getAccessToken,
  accessTokenExists,
  deleteAccessToken,
  logoutAndNotifyOtherTabs,
  subscribeToLogoutFromOtherTab,
};
